import { Wordmark } from "@/components/Logo";
import { EMAIL } from "@/lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)] overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-14 flex flex-col md:flex-row gap-8 md:items-center justify-between">
      <Wordmark />
      <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="font-mono text-sm text-[var(--ink-dim)] hover:text-[var(--gold)] transition-colors">{EMAIL}</a>
      <span className="font-mono text-xs text-[var(--ink-dim)]">© 2026 King App Graphics</span>
    </div>
    <div aria-hidden className="font-display font-black text-[19vw] leading-[0.8] text-center text-gilded opacity-20 select-none -mb-[3vw]">KING</div>
  </footer>
);
